import { useState } from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { Container, Nav, Navbar } from 'react-bootstrap'
import homeIcon from '../images/icon-home.svg'

export default function Header ({ links, hide }) {
  const location = useLocation()
  const navigate = useNavigate()
  const [expanded, setExpanded] = useState(false)

  function handleNavClick (event, path, index) {
    event.preventDefault()
    setExpanded(false)

    const activeLinkIndex = links.findIndex(link => link.path === location.pathname)

    let direction
    if (location.pathname === '/ames-family-history/family' && index === 0) {
      direction = 'down'
    } else if (activeLinkIndex !== index) {
      direction = index > activeLinkIndex ? 'left' : 'right'
    }

    navigate(path, { state: { direction } })
  }

  return (
    <header>
      <Navbar expand='lg' className={`fixed-top ${hide && 'hide'}`} expanded={expanded}>
        <Container fluid>
          <Navbar.Brand as={NavLink} to='/' state={{ direction: 'right' }} className='flex-grow-1 d-lg-flex justify-content-center' onClick={() => setExpanded(false)}>
            <img src={homeIcon} alt='home' />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls='basic-navbar-nav' onClick={() => setExpanded(!expanded)} />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav as='ul' className='flex-grow-1 justify-content-center'>
              {links.map((link, index) => (
                <Nav.Item key={index}>
                  <Nav.Link
                    as={NavLink}
                    to={link.path}
                    className={(navData) => (navData.isActive ? 'active' : 'none')}
                    onClick={(event) => handleNavClick(event, link.path, index)}
                  >
                    {link.label}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Navbar.Collapse>
          <div className='flex-grow-1 d-none d-lg-block' />
        </Container>
      </Navbar>
    </header>
  )
}
